import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TableLayout from "../../../components/TableLayout";
import u1 from "../../../Assets/images/authBg.png";
import { Link } from "react-router-dom";
import CustomPagination from "../../../components/Common/CustomPagination";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import SetCommissionPop from "../../../components/Modals/SetcommissionPop";
import dataHandler from "../../../hooks/dataHandler";
import TableActions from "../../../components/Common/TableActions";
import {
  COMMISSIONS_LIST,
  DELETE_COMMISSION,
  GET_EARNING_REPORT,
  SET_COMMISSION,
} from "../../../services/ApiCalls";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
} from "../../../utilities/const";
import moment from "moment";
import {
  catchAsync,
  checkResponse,
  exportCsvHandler,
} from "../../../utilities/utilities";
import Filter from "../../../components/Common/Filter";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import CountryFilter from "../../../components/Common/CountryFilter";
import RevenueGraph from "./component/RevenueComparisionTable";
import RoomBookingGraph from "./component/MonthlySummary";
import AdminUserStat from "../../../components/Common/AdminUserStat";
import HotelAdminFilter from "../../../components/Common/HotelAdminFilter";

const ManageEarning = () => {
  const { t } = useTranslation();
  const [exportLoader, setExportLoader] = useState();
  const [commissionModel, setCommissionModel] = useState({
    show: false,
    dumpId: "",
    commission: "",
  });

  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    refetch,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: GET_EARNING_REPORT,
  });

  const column = [
    {
      head: t("manageEarning.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },
    {
      head: t("manageEarning.columns.time"),
      accessor: "time",
      component: (item, key, arr) => (
        <>{moment(item.date_created_utc).format("MM-DD-YYYY , HH:MM")}</>
      ),
    },
    {
      head: t("manageEarning.columns.type"),
      accessor: "type",
    },
    {
      head: t("manageEarning.columns.amount"),
      accessor: "amount",
    },
    {
      head: t("manageEarning.columns.earning"),
      accessor: "balance",
    },
    {
      head: t("manageEarning.columns.description"),
      accessor: "description",
    },
  ];

  const dummyData = [
    {
      _id: "1",
      date_created_utc: new Date("2025-09-01T10:30:00Z"),
      type: "Booking",
      amount: 150,
      balance: 50,
      description: "Booking for Deluxe Room",
    },
    {
      _id: "2",
      date_created_utc: new Date("2025-09-02T14:45:00Z"),
      type: "Refund",
      amount: 75,
      balance: -25,
      description: "Refund processed for cancelled booking",
    },
    {
      _id: "3",
      date_created_utc: new Date("2025-09-03T09:15:00Z"),
      type: "Service Charge",
      amount: 30,
      balance: 10,
      description: "Extra service charge for room service",
    },
    {
      _id: "4",
      date_created_utc: new Date("2025-09-04T18:00:00Z"),
      type: "Booking",
      amount: 200,
      balance: 75,
      description: "Booking for Suite Room",
    },
    {
      _id: "5",
      date_created_utc: new Date("2025-09-05T12:20:00Z"),
      type: "Cancellation Fee",
      amount: 50,
      balance: 20,
      description: "Fee applied for late cancellation",
    },
  ];

  const commissionSetHandler = catchAsync(async (data) => {
    const res = await SET_COMMISSION({ ...data, _id: commissionModel.dumpId });
    const success = checkResponse({ res, showSuccess: true });
    if (success) {
      setCommissionModel({ show: false, commission: "", dumpId: "" });
      refetch();
    }
  });

  console.log(data, "data from API");

  return (
    <>
      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        type={"delete"}
        confirmHandler={() =>
          deleteHandler(() =>
            DELETE_COMMISSION({
              _id: deleteModel.dumpId,
            })
          )
        }
      />
      <SetCommissionPop
        show={commissionModel.show}
        setCommissionModel={setCommissionModel}
        hideHandle={() =>
          setCommissionModel({ show: false, dumpId: "", commission: "" })
        }
        commission={commissionModel.commission}
        submitHandler={commissionSetHandler}
      />
      <section className="manageCommissions  position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("manageEarning.title")}
                </h4>
                {/* <div className="d-flex align-items-center gap-2">
                  <label
                    htmlFor="countryFilter"
                    className="form-label m-0 fw-semibold text-muted"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Filter by Country
                  </label>
                  <CountryFilter
                    id="countryFilter"
                    body={body}
                    setBody={setBody}
                  />
                </div> */}
              </div>
            </Col>
<Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <HotelAdminFilter
                    body={body}
                    // searchHandler={searchHandler}
                    setBody={setBody}
                    type="graph"
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
              </div>
            </Col>
            <Col lg="12">
              <RoomBookingGraph platform={data} />
            </Col>

            
            {/* <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        type="button"
                        onClick={() =>
                          exportCsvHandler("earning", setExportLoader)
                        }
                      >
                        {exportLoader ? <ButtonLoader /> : t("manageEarning.buttons.exportCsv")}
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </Col> */}

            {/* <Col lg="12" className="my-2">
              <TableLayout column={column} data={dummyData} loader={loader} />
              <CustomPagination
                total={total}
                body={body}
                setBody={setBody}
                pageChangeHandler={paginationHandler}
              />
            </Col> */}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageEarning;
